import { helpColorsTop } from './AppConnectionHelpButton.model';
import {
	StyledColor,
	StyledColorWrapper,
	StyledContainer,
} from './AppConnectionHelpColors.styled';

const AppConnectionHelpColors = ({
	colors,
	mapNumber,
}: {
	colors: string[];
	mapNumber: number;
}) => {
	return (
		<StyledContainer style={{ top: helpColorsTop[mapNumber - 1] }}>
			{colors.map((color) => (
				<StyledColorWrapper key={color}>
					<StyledColor $color={color} />
				</StyledColorWrapper>
			))}
		</StyledContainer>
	);
};

export { AppConnectionHelpColors };
